// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-sumo-container[data-v-3536e9c5]{height:100vh;background-size:cover!important;background-position:center bottom -200px!important;background-repeat:no-repeat!important}", ""]);
// Exports
module.exports = exports;
